var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cgateways-form ng-if=\"$ctrl.loaded\" gateway=\"$ctrl.gateway\" on-submit=\"$ctrl.updateGateway()\"\u003E\u003C\u002Fgateways-form\u003E";;return pug_html;};
module.exports = template;